import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import Select from "react-select";
import * as XLSX from "xlsx";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { CUSTOM_SELECT_DROPDOWN_STYLE, DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { Calendar } from "../../../common/imagePath";
import ReactDatetime from "react-datetime";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const OpenPurchaseOrderDetail = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);
  const [openbalance, setOpenBalance] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [receiveqty, setReceiveqty] = useState(0);
  const [startdate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [enddate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download
  const handleDownload = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    pdf.save("document.pdf");
  };

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const renderAccordionIcon = (index) => {
    if (activeAccordion === index) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    } else {
      return <FontAwesomeIcon icon={faChevronDown} />;
    }
  };
  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {

    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "")

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    
    setLoading(true)

    axios
      .get(
        `${config.reportsBaseUrl}/reports/openpurchaseorderdetail?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            Vendor: String(el?.Vendor),
            
          }));
          setResponseData(FilterData);
          setData(FilterData);
          setRowCount(res.data.ResponseData[0].TotalRecord)

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(()=>{
   apicall()
  },[
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,])
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);

    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, [startdate, enddate]);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData?.reduce((total, report) => {
      const reportTotal = Number(report.TotalAMT);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const calculateQtySum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.QTY);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setQuantity(sum);
  };

  const calculateReceiveQtySum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.ReceivedQTY);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setReceiveqty(sum);
  };

  const calculateTotal = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Receivedamt);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalAmount(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotal();
    calculateReceiveQtySum();
    calculateQtySum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  // const columnDefs = [
  //   { field: "Vendor", rowGroup: true },
  //   { field: "CreatedDate" },
  //   { field: "BillNo" },
  //   { field: "product" },
  //   { field: "Account" },
  //   {
  //     field: "QTY",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.QTY, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  //   {
  //     field: "ReceivedQTY",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.ReceivedQTY, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  //   {
  //     field: "qty",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.qty, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  //   {
  //     field: "TotalAMT",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.TotalAMT, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  //   {
  //     field: "Receivedamt",
  //     width: 200,
  //     enableValue: true,
  //     suppressMenu: true,
  //     filter: "agNumberColumnFilter",
  //     aggFunc: "sum",
  //     valueGetter: function (params) {
  //       // Parse the string OpenBalance and return as an integer
  //       const amount = parseInt(params.data.Receivedamt, 10);
  //       return isNaN(amount) ? 0 : amount;
  //     },
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size:"100",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.Date);
        if (transactionDate.isValid()) {
          return transactionDate.format("YYYY-MM-DD");
        } else {
          return "";
        }
      },
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size:"110",
    },
    {
      header: "Vendor",
      accessorKey: "Vendor",
      filterFn: "contains",
      size:"110",
    },
    {
      header: "Product / Service",
      accessorKey: "Product",
      filterFn: "contains",
      size:"110",
    },
    {
      header: "Account",
      accessorKey: "Account",
      filterFn: "contains",
    },
    {
      header: "QTY",
      accessorKey: "BackorderedQuantity",
      filterFn: "contains",
      size:"110",
      Cell: ({ row }) => Number(row.original.BackorderedQuantity).toFixed(2),
      // aggregationFn: 'add', 
      // AggregatedCell: ({ cell, table }) => (
      //   <>
      //     Total Qty: {' '}
      //     {/* {table.getColumn(cell.row.groupingColumnId ?? '').columnDef.header}:{' '} */}
      //     <Box
      //       sx={{ color: 'info.main', display: 'inline', fontWeight: 'bold' }}
      //     >
      //       {`${cell.getValue()}`}
      //     </Box>
      //   </>
      // ),
      // Footer: () => (
      //   <Stack>
      //     Max Age:
      //     <Box color="warning.main">{Math.round(maxAge)}</Box>
      //   </Stack>
      // ),
    },
    {
      header: "Received QTY",
      accessorKey: "QuantityPurchased",
      Cell: ({ row }) => Number(row.original.QuantityPurchased).toFixed(2),
    },
    {
      header: "Backordered QTY	",
      accessorKey: "BackorderedQuantity",
    },
    {
      header: "Total Amount",
      accessorKey: "TotalAmount",
      filterFn: "contains",
      size:"110",
      Cell: ({ row }) => {
        return (
          <div style={{textAlign: 'end'}}>
            {Number(row.original.TotalAmount ? row.original.TotalAmount : 0).toFixed(2)}
          </div>
        );
      },
    },
    {
      header: "Received Amount",
      accessorKey: "ReceivedAmount",
      filterFn: "contains",
      size:"110",
      enableSorting : false ,
      Cell: ({ row }) => {
        return (
          <div style={{textAlign: 'end'}}>
            {Number(row.original.ReceivedAmount ? row.original.ReceivedAmount : 0).toFixed(2)}
          </div>
        );
      },
      // Cell: ({ row }) => {
      //   const ReceivedAmount = parseFloat(row?.original?.ReceivedAmount);
    
      //   if (isNaN(ReceivedAmount) || ReceivedAmount === 0) {
      //     return <div style={{ textAlign: "end" }}></div>;
      //   } else {
      //     return (
      //       <div style={{ textAlign: "end" }}>
      //         {`${ReceivedAmount.toFixed(2)}`}
      //       </div>
      //     );
      //   }
      // },
    },				  
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filterFn: "contains",
      size:"110",
      filtrable: false,
      Cell: ({ row }) => {
        return (
          <div style={{textAlign: 'end'}}>
            {Number(row.original.OpenBalance ? row.original.OpenBalance : 0).toFixed(2)}
          </div>
        );
      },
    },
    {
      header: "Rate",
      accessorKey: "CostPrice",
      filterFn: "contains",
      size:"110",
    },
    {
      header: "Sku",
      accessorKey: "SKU",
      filterFn: "contains",
      size:"110",
      Cell: ({ row }) => row.original?.SKU ==null ? "" : row.original?.SKU,
    },
    {
      header: "Rate",
      accessorKey: "CostPrice",
      filterFn: "contains",
      // size:"110",
      // Cell: ({ row }) => row.original?.SKU ==null ? "" : row.original?.SKU,
    },
    {
      header: "Memo/Description",
      accessorKey: "Description",
      filterFn: "contains",
    },
    {
      header: "Last Modified By",
      accessorKey: "ModifiedBy",
      filterFn: "contains",
    },
    {
      header: "Last Modified Date",
      accessorKey: "LastModified",
      size:"140",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.LastModified);
        if (transactionDate.isValid()) {
          return transactionDate.format("YYYY-MM-DD(HH:mm:ss)");
        } else {
          return "";
        }
      },
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      size:"140",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.CreateDate);
        if (transactionDate.isValid()) {
          return transactionDate.format("YYYY-MM-DD(HH:mm)");
        } else {
          return "";
        }
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
    },
    {
      header: "Sku",
      accessorKey: "SKU",
      filterFn: "contains",
      size:"110",
      Cell: ({ row }) => row.original?.SKU ==null ? "" : row.original?.SKU,
    },
    {
      header: "CLIENT/VENDOR MESSAGE",
      accessorKey: "VendorMessage",
      filterFn: "contains",
    },
  ]);

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Vendor</th>' +
        '<th style="padding: 7px;">CreatedDate</th>' +
        '<th style="padding: 7px;">Bill No</th>' +
        '<th style="padding: 7px;">product</th>' +
        // '<th style="padding: 7px;">ReceivedQTY</th>' +
        '<th style="padding: 7px;">TotalAMT</th>' +
        '<th style="padding: 7px;">Received Amount</th>' +
        '<th style="padding: 7px;">Open Balance</th>' +
        // '<th style="padding: 7px;">Account</th>' +
        // '<th style="padding: 7px;">QTY</th>' +
        // '<th style="padding: 7px;">qty</th>' +

        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Vendor +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].CreatedDate).format("YYYY-MM-DD") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Num +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Product +
            "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].Account +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // Number(newData[index - 1].QTY).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // Number(newData[index - 1].ReceivedQTY).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // newData[index - 1].qty +
            // "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(newData[index - 1].TotalAmount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            (newData[index - 1].ReceivedAmount == undefined ? "" : newData[index - 1].ReceivedAmount )+
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            Number(newData[index - 1].OpenBalance).toFixed(2) +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("OpenPurchaseOrder_Details_.pdf");
        setLoading(false);
      },
    });
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `OpenPurchaseOrder_Details_.xlsx`);
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `OpenPurchaseOrder_Details_.xlsx`);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  // const onGridReady = useCallback((params) => {
  //   setLoading(true);

  //   axios
  //     .get(
  //       `${config.reportsBaseUrl
  //       }/reports/openpurchaseorderdetail?startdate=${""}&enddate=${""}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData);
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData.OrderList);
  //         setData(res.data.ResponseData.OrderList);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const totalFooterRow = {
    Vendor: "Total",
    QTY: quantity,
    ReceivedQTY: receiveqty,
    TotalAMT: totalSum,
    Receivedamt: totalamount,
  };




  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Open Purchase Order Detail
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-sm-4 mt-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3 p-lg-medium">
                  Report period
                </label>
                <div className="col-md-9 custom-search-select">
                  <select
                    as="select"
                    className="form-control"
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onInput={(event) => {
                      handleDropdownChange(event);
                      // handleChange(event);
                    }}
                    // onChange={handleChange}
                  >
                    {selectedDate.map((u) => (
                      <option value={u.ID}> {u.Name} </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-sm-8 mt-4">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="submit"
              className="btn btn-primary mb-3 mt-0"
              // style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // value={reportdropdown.find((el,i)=>el.value==selectReport)}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find(e => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            {/* <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary pull-right"
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div> */}

          </div>

          {/* Receipt */}

          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="P">SonarPos</h6>
                  <h6 className="fw-bold p-regular">
                    Open Purchase Order Detail
                  </h6>
                  <div className="row mb-2">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6>
                    <p className="p-regular">
                      Date: {startdate} - {enddate}
                    </p> */}
                    <p>
                      Date:{" "}
                      {startdate === "" && enddate === ""
                        ? "All Data"
                        : startdate + " - " + enddate}
                    </p>
                  </div>
                </div>
              </div>
              <hr />

              <div>
                {/* <MaterialReactTable
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  columns={columns}
                  data={responseData}
                  enableColumnResizing
                  enableColumnFilters
                  enableGrouping
                  sortDescFirst
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    grouping: ["Product"], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    sorting: [{ id: "state", desc: false }], //sort by state by default
                    columnVisibility: {
                      SKU: false,
                      CostPrice: false,
                      CreateDate: false,
                      VendorMessage: false,
                      Description: false,
                      ModifiedBy: false,
                      LastModified: false,
                    }
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300, 500],
                  }}
                  manualFiltering
                  manualPagination
                  manualSorting
                  // muiToolbarAlertBannerProps={
                  //   isError
                  //     ? {
                  //         color: "error",
                  //         children: "Error loading data",
                  //       }
                  //     : undefined
                  // }
                  muiTableBodyProps={{
                    sx: () => ({
                      "& tr:nth-of-type(even)": {
                        backgroundColor:
                          "var(--datatable-row-background-color)",
                        //'rgb(237 237 233 / 63%)'
                      },
                      "& td": {
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },

                      "& tr": {
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      },
                    }),
                  }}
                  muiTableHeadCellProps={{
                    sx: (theme) => ({
                      background: "var(--datatable-row-background-color)", //'#e9e9e9',
                      borderRight:
                        "1px solid var(--datatable-row-background-hover-color)",
                      lineHeight: "16px",
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "var(--primary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiToolbarAlertBannerProps={
                    // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined
                    {
                      isError: () => ({
                        color: "error",
                        children: "Error loading data",
                      }),
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }
                  }
                  muiSelectCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  muiSelectAllCheckboxProps={{
                    sx: (theme) => ({
                      lineHeight: "16px",
                      fontWeight: "400",
                      fontSize: "12px",
                      color: "var(--prinary-color-800)",
                      fontFamily: "Inter",
                    }),
                  }}
                  onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    columnFilters,  
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                    sx={{
                      display: "flex",
                      gap: "0.3rem",
                      p: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={onBtExport}
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Excel
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleExportRows(
                          table.getSelectedRowModel().rows
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Excel
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      color="primary"
                      //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                      onClick={() =>
                        downloadPDF(
                          "",
                          "alldata",
                          table.getVisibleFlatColumns()
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export All In Pdf
                    </Button>
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        downloadPDF(
                          table.getSelectedRowModel().rows,
                          "selectedrow"
                        )
                      }
                      startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Export Selected Rows in Pdf
                    </Button>
                  </Box>
                  )}
                /> */}

              <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Open Purchase Order Detail"
                  columns={columns}
                  data={responseData}
                  startdate={startdate}
                  enddate={enddate}
                  columnGrouping={["Product"]}
                  columnsVisibility={{
                    SKU: false,
                    CostPrice: false,
                    VendorMessage: false,
                    CreateDate: false,
                    CreatedBy: false,
                    Description: false,
                    ModifiedBy: false,
                    LastModified: false,
                    CostPrice:false
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenPurchaseOrderDetail;
